import React, { memo } from 'react'
import { Tag, TAG_STYLE, TAG_SIZE } from 'transfix-ui/components/Tag'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { InfoIcon } from 'transfix-icons'

interface IShareLoadTooltipProps {
  driverId?: string
}

export const ShareLoadTooltip = memo<IShareLoadTooltipProps>(({ driverId = '' }) => {
  const { getFlag } = useFeatureFlagContext()
  const { enabled: isFmsOneTimeSmsLoadShareEnabled } = getFlag('fmsOneTimeSmsLoadShare')
  return (
    <div className={isFmsOneTimeSmsLoadShareEnabled ? 'flex' : 'share-load-search-tag'}>
      <div className='flex-shrink mr2'>
        <Tag label='What is shared?' size={TAG_SIZE.small} tagStyle={TAG_STYLE.info} />
      </div>
      <div className='flex flex-auto items-center'>
        <Tooltip
          position='bottom'
          type='light'
          effect='solid'
          trigger={
            <div className='flex items-center text-secondary'>
              <InfoIcon />
            </div>
          }>
          <div className='share-load-tooltip'>
            <strong className='dib mb2'>Basic load info</strong>
            {!driverId ? (
              <ul>
                <li>
                  Pickup and dropoff address, appointments, facility info, and pickup and dropoff
                  instructions
                </li>
                <li>Customer name</li>
                <li>Load ID and PO numbers</li>
                <li>Miles Equipment info</li>
                <li>Additional notes</li>
                <li>
                  Links created while the load is unassigned do not allow drivers to update load
                  statuses
                </li>
              </ul>
            ) : (
              <ul>
                <li>Pickup address, appointment, facility info, and pickup instructions.</li>
                <li>Dropoff address, appointment, facility info, and dropoff instructions.</li>
                <li>Commodity, weight, packaging, and quantity </li>
                <li>Customer name</li>
                <li>Load ID and PO numbers</li>
                <li>Miles</li>
                <li>Equipment info</li>
                <li>Additional notes</li>
                <li>Ability to update load status</li>
              </ul>
            )}
          </div>
        </Tooltip>
      </div>
    </div>
  )
})
